module.exports = __webpack_public_path__ + "static/media/card-focus.b7869219.svg";